export const APP_NAME = 'recentDeals';
export const RECENT_DEALS_ROOT_ROUTE = '/recent-deals';
